<template>
  <div class="statement-con">
    <div class="time-picker-con">
      <div>
        <el-select class="select-time" v-model="timeType" @change="handleSearch()" size="small">
          <el-option :value="1" label="创建时间"></el-option>
          <el-option :value="2" label="进线时间"></el-option>
        </el-select>
        <a class="time-opt" :class="type === 'today' && 'checked'" @click="handleChangeType('today')">今日</a>
        <a class="time-opt" :class="type === 'day' && 'checked'" @click="handleChangeType('day')">昨日</a>
        <a class="time-opt" :class="type === 'week' && 'checked'" @click="handleChangeType('week')">近7天</a>
        <a class="time-opt" :class="type === 'month' && 'checked'" @click="handleChangeType('month')">近30天</a>
        <el-date-picker
          class="time-select"
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="handleTimeChange"  
          :clearable="false"
          :picker-options="options"
        >
        </el-date-picker>
        <el-button type="primary" size="mini" class="search-btn" @click="handleSearch">查询</el-button>
      </div>
    </div>
    <div class="customer-report">
      <h1>客户新增和进线汇总数
        <el-popover
          placement="top-start"
          width="500"
          trigger="hover">
          <div class="sale-report-hover-tips" v-if="customerTotal && customerTotal.multi_business_rate_name == '多次报备客户占比'">
            <p>当选择创建时间时，指在时间段内创建的商户新客户中有超过 1 次报备的客户占比。当选择进线时间时，指时间段内有进线的客户中有超过 1 次报备的客户占比（包含手动推送到公客池的新客户）</p>
          </div>
          <div class="sale-report-hover-tips" v-if="customerTotal && customerTotal.multi_business_rate_name == '多次带看客户占比'">
            <p>当选择创建时间时，指在时间段内创建的商户新客户中有超过 1 次带看的客户占比。当选择进线时间时，指时间段内有进线的客户中有超过 1 次带看的客户占比（包含手动推送到公客池的新客户）</p>
          </div>
          <i class="iconfont iconinfo sale-funnel-info" slot="reference"></i>
        </el-popover>
      </h1>
      <div class="data-cont" v-if="customerTotal">
        <div class="item item-count1">
          <div class="total">
            <p>{{ customerTotal.customer_total }}</p>
            客户总数
          </div>
          <div class="percent" v-if="timeType == 2">
            <p class="top">
              <label class="floatL">新客 {{ customerTotal.new_customer_total }}</label>
              <el-progress class="floatR" :percentage="newCusPer" :text-inside="true"></el-progress>
            </p>
            <p>
              <label class="floatL">旧客 {{ customerTotal.old_customer_total }}</label>
              <el-progress class="floatR" :percentage="oldCusPer" color="#6e95ff" :text-inside="true"></el-progress>
            </p>
          </div>
        </div>
        <div class="item item-count2" v-if="customerTotal">
          <el-progress type="dashboard" :percentage="customerTotal.multi_business_rate" define-back-color="#000" color="#849EFF"></el-progress>
          <p>{{customerTotal.multi_business_rate_name}}</p>
        </div>
      </div>
      <h1>客户明细</h1>
      <customer-data :getParams="getParams" ref="customerDataRef"></customer-data>
    </div>
  </div>
</template>
<script>
import customerData from './components/customerData';
import {getCustomerTotal} from '@/api/sale';
export default {
  name: 'CustomerStatement',
  components: {
    customerData
  },
  data () {
    return {
      type: 'today',
      dateRange: [],
      timeType:1,
      options: {
        disabledDate : time => {
          const now = new Date();
          now.setFullYear(now.getFullYear() - 1);
          return time.getTime() > Date.now() - 86400000 || time.getTime() < now.getTime();
        }
      },
      customerTotal:null,
      customerPer:0,
      newCusPer:0,
      oldCusPer:0
    }
  },
  created () {
    this.changeType('today');
    this.handleSearch()
  },
  methods: {
    handleSearch () {
      this.initTotal()
    },
    handleTimeChange () {
      if (!this.dateRange) this.type = 'today';
      else this.type = 'range';
    },
    handleChangeType (type) {
      this.changeType(type);
      this.handleSearch();
    },
    changeType (type) {
      this.type = type;
      const startDate = new Date();
      const endDate = new Date();
      if (type == 'today') {
        startDate.setDate(startDate.getDate());
        endDate.setDate(endDate.getDate());
      }else if (type == 'day') {
        startDate.setDate(startDate.getDate() - 1);
        endDate.setDate(endDate.getDate() - 1);
      }else if (type === 'week') {
        startDate.setDate(startDate.getDate() - 7);
        endDate.setDate(endDate.getDate() - 1);
      } else if (type === 'month') {
        startDate.setDate(startDate.getDate() - 30);
        endDate.setDate(endDate.getDate() - 1);
      }
      this.dateRange = [`${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`, `${endDate.getFullYear()}-${endDate.getMonth()+1}-${endDate.getDate()}`];
    },
    async initTotal(){
      try {
        const res = await getCustomerTotal({
          start_date: this.dateRange[0],
          end_date: this.dateRange[1],
          time_option :this.timeType
        });
        this.customerTotal = res
        this.customerPer =  res.multi_look_total == 0 || res.multi_report_total == 0 ? 0 : Number((res.multi_report_total / res.multi_look_total * 100).toFixed(2));                
        if(this.timeType == 2){
          this.newCusPer =  res.new_customer_total == 0 || res.new_customer_total == 0 ? 0 : Number((res.new_customer_total / res.customer_total * 100).toFixed(2));                
          this.oldCusPer =  res.old_customer_total == 0 || res.old_customer_total == 0 ? 0 : Number((res.old_customer_total / res.customer_total * 100).toFixed(2));                
        }
        this.$refs['customerDataRef'].search();
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    getParams () {
      return {
        start_date: this.dateRange[0],
        end_date: this.dateRange[1],
        time_option:this.timeType
      }
    },
  }
}
</script>
<style lang="less">
@import url('~@/assets/style/report/statement.less');
</style>
<style lang="less" scoped>
.statement-con{
  padding: 0 !important;
  background-color: #fff;
}
</style>